import { date } from "../utils/common"
export function dateYmd(value) {
    return value ? date(value, 'Y-M-D') : ''
}
export function dateM(value) {
    return date(value, 'Y-M');

}
export function dateYmdH(value) {
    return date(value, 'Y-M-D h:m:s');
}
export function money(value, key) {
    let money = parseFloat(value)
    if (!value) {
        return
    }
    if (String(value).indexOf('.') == -1) {
        money = money + '.00'
    }

    if (money && money != null) {
        money = String(money);
        var left = money.split('.')[0],
            right = money.split('.')[1];
        right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00';
        var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
        if (temp) {
            return (Number(money) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('') + right;
        } else {
            return '0.00'
        }
    } else if (money === 0) { // 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
        return '0.00';
    } else {
        return '';
    }
}
// 将毫秒转成 天时分秒
export function timeCount(resttime) {
    resttime = resttime/1000
    var obj = {},
        misecperday = 60 * 60 * 24,
        misecperHour = 60 * 60,
        misecperMin = 60,
        misecpeSec = 1;
    obj.days = Math.floor(resttime / misecperday);
    //剩余的小时
    obj.hours = Math.floor((resttime - obj.days * misecperday) / misecperHour);
    //剩余的分钟
    obj.minutes = Math.floor((resttime - obj.days * misecperday - obj.hours * misecperHour) / misecperMin);
    //剩余的秒数
    obj.seconds = Math.floor((resttime - obj.days * misecperday - obj.hours * misecperHour - obj.minutes * misecperMin) / misecpeSec);
    var result = ''
    if(obj.days){
        result += obj.days + '天'
    }
    if(obj.hours){
        result += obj.hours + '时'
    }
    if(obj.minutes){
        result += obj.minutes + '分'
    }
    if(obj.seconds){
        result += obj.seconds + '秒'
    }
    return result
}
// 判断为整数时，加.00
export function moneyInt(value) {
    if (!value) {
        return "0.00"
    }
    let money = parseFloat(value)
    if (!value) {
        return
    }
    if (String(value).indexOf('.') == -1) {
        money = money + '.00'
    }

    return money
}

export function moneyZero(value) {
    let money = parseFloat(value)
    if (!value) {
        return
    }
    if (money === 0) {
        money = ''
        return
    }
    if (String(value).indexOf('.') == -1) {
        money = money + '.00'
    }

    if (money && money != null) {
        money = String(money);
        var left = money.split('.')[0],
            right = money.split('.')[1];
        right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00';
        var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
        if (temp) {
            return (Number(money) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('') + right;
        } else {
            return '0.00'
        }
    } else if (money === 0) { // 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
        return '0.00';
    } else {
        return '';
    }
}
/**
 * 将金额数字转为中文
 * @param {*} n 
 */
export function moneyFormatChinese(value) {
    // 标记一个数是否为负数，如果是最终结果需要加个 负字
    let isNegative = false
    if (!value || value == 0) {
        return '零元整'
    }
    if (value < 0) {
        value = Math.abs(value)
        isNegative = true
    }
    if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(value)) {
        return "";
    }
    var unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
        result = "";
    value += "00";
    var p = value.indexOf('.');
    if (p >= 0) {
        value = value.substring(0, p) + value.substr(p + 1, 2);
    }
    unit = unit.substr(unit.length - value.length);
    for (var i = 0; i < value.length; i++) {
        result += '零壹贰叁肆伍陆柒捌玖'.charAt(value.charAt(i)) + unit.charAt(i);
    }
    if (isNegative) {
        return "负" + result.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
    } else {
        return result.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
    }
}
export function numberdot2(val) {
    let value = Number(val || 0) || 0
    return value.toFixed(2)
}

export function accountSplit(money) {
    if (money && money != null) {
        money = String(money);
        var left = money.split('.')[0], right = money.split('.')[1];
        right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00';
        var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
        return (Number(money) < 0 ? "-" : "") + temp.join(',').split('').reverse().join('') + right;
    } else if (money === 0) {   //注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
        return '0.00';
    } else {
        return "";
    }
}



// WEBPACK FOOTER //
// ./src/filters/index.js